export default __webpack_public_path__ + "assets/home-two-two.ac31f221665ec2b9ddaab33aa27b25bd.png";